import { render, staticRenderFns } from "./ProspectForm.vue?vue&type=template&id=703f96a1&scoped=true&"
import script from "./ProspectForm.vue?vue&type=script&lang=ts&"
export * from "./ProspectForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectForm.vue?vue&type=style&index=0&id=703f96a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f96a1",
  null
  
)

export default component.exports